/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCycleDays } from 'app/entities/cycle-day/cycle-day.reducer';
import { createEntity, getEntity, reset, updateEntity } from './mucus.reducer';

export const MucusUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const cycleDays = useAppSelector(state => state.cycleDay.entities);
  const mucusEntity = useAppSelector(state => state.mucus.entity);
  const loading = useAppSelector(state => state.mucus.loading);
  const updating = useAppSelector(state => state.mucus.updating);
  const updateSuccess = useAppSelector(state => state.mucus.updateSuccess);

  const handleClose = () => {
    navigate(`/mucus${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCycleDays({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.feeling !== undefined && typeof values.feeling !== 'number') {
      values.feeling = Number(values.feeling);
    }
    if (values.texture !== undefined && typeof values.texture !== 'number') {
      values.texture = Number(values.texture);
    }
    if (values.value !== undefined && typeof values.value !== 'number') {
      values.value = Number(values.value);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...mucusEntity,
      ...values,
      cycleDay: cycleDays.find(it => it.id.toString() === values.cycleDay?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...mucusEntity,
          cycleDay: mucusEntity?.cycleDay?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.mucus.home.createOrEditLabel" data-cy="MucusCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.mucus.home.createOrEditLabel">Create or edit a Mucus</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="mucus-id"
                  label={translate('tinyMedicRestApp.mucus.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.feeling')}
                id="mucus-feeling"
                name="feeling"
                data-cy="feeling"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.texture')}
                id="mucus-texture"
                name="texture"
                data-cy="texture"
                type="text"
              />
              <ValidatedField label={translate('tinyMedicRestApp.mucus.value')} id="mucus-value" name="value" data-cy="value" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.comments')}
                id="mucus-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.active')}
                id="mucus-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.draft')}
                id="mucus-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.cursor')}
                id="mucus-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.lastUpdated')}
                id="mucus-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.microSec')}
                id="mucus-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.timestampEntry')}
                id="mucus-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mucus.isPresent')}
                id="mucus-isPresent"
                name="isPresent"
                data-cy="isPresent"
                check
                type="checkbox"
              />
              <ValidatedField
                id="mucus-cycleDay"
                name="cycleDay"
                data-cy="cycleDay"
                label={translate('tinyMedicRestApp.mucus.cycleDay')}
                type="select"
              >
                <option value="" key="0" />
                {cycleDays
                  ? cycleDays.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/mucus" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MucusUpdate;
